import React from 'react';
import {Tab, Tabs} from '@mui/material';
import {TabContext, TabPanel} from "@mui/lab";
import BuyerSpaceUsageReport from '../spaceUsage/BuyerSpaceUsageReport';
import SecurSpaceContainer from '../../components/common/SecurSpaceContainer'
import BuyerInvoicesReport from "../buyer/BuyerInvoicesReport/BuyerInvoicesReport";
import BuyerInterchangesReport from "../buyer/BuyerInterchangesReport/BuyerInterchangesReport";
import BuyerCurrentInventoryReport from "../buyer/BuyerCurrentInventoryReport/BuyerCurrentInventoryReport";
import {SecurSpaceReportContainer} from "../../components/common";
import {styled} from "@mui/material/styles";
import {TabContextContainer} from "../../components/common/reports/tabs/TabContextContainer";
import {TabsContainer} from "../../components/common/reports/tabs/TabsContainer";
import {usePathTabMapping} from "../../hooks/routing/usePathTabMapping";
import type {Account} from "../../types/Account";

const TabsBorderBottomGrey200 = styled(Tabs)(({theme}) => ({
  borderBottom: `${theme.palette.grey[200]} solid 0.07rem`
}));

const TAB_ROUTES = [
  { navPath: '/reports/buyer-inventory', tabName: 'currentInventory' },
  { navPath: '/reports/interchanges', tabName: 'interchanges' },
  { navPath: '/reports/buyer-invoices', tabName: 'invoices' },
  { navPath: '/reports/space-usage', tabName: 'spaceUsage' },
];

interface ReportOverviewProps {
  initialTab?: string;
  account: Account;
}

const ReportOverview = ({
  initialTab = 'currentInventory',
  account
}: ReportOverviewProps) => {
  const { currentTab, handleTabChange } = usePathTabMapping(TAB_ROUTES, initialTab);

  return (
      <SecurSpaceContainer>
        <SecurSpaceReportContainer>
          <TabContextContainer>
            <TabContext value={currentTab}>
              <TabsContainer>
                <TabsBorderBottomGrey200
                  variant={'fullWidth'}
                  value={currentTab}
                  onChange={handleTabChange}
                  aria-label={'Report Tabs'}
                  textColor={'secondary'}
                >
                  <Tab value={'currentInventory'} label='Current Inventory'/>
                  <Tab value={'interchanges'} label='Interchanges'/>
                  <Tab value={'invoices'} label='Invoices'/>
                  <Tab value={'spaceUsage'} label='Space Usage'/>
                </TabsBorderBottomGrey200>
                <TabPanel value={'currentInventory'}>
                  <BuyerCurrentInventoryReport/>
                </TabPanel>
                <TabPanel value={'interchanges'}>
                  <BuyerInterchangesReport/>
                </TabPanel>
                <TabPanel value={'invoices'}>
                  <BuyerInvoicesReport/>
                </TabPanel>
                <TabPanel value={'spaceUsage'} sx={{ padding: '1.5em 0em' }}>
                  <BuyerSpaceUsageReport account={account}/>
                </TabPanel>
              </TabsContainer>
            </TabContext>
          </TabContextContainer>
        </SecurSpaceReportContainer>
      </SecurSpaceContainer>
  );
};

export default ReportOverview;
